import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOctaveComponent } from './simple-icons-octave.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOctaveComponent ],
    exports:      [ SimpleIconsOctaveComponent ],
    bootstrap:    []
})
export class SimpleIconsOctaveModule {}
